import React, { Children } from 'react';
import { NewsfilateHeader } from '../components/NewsfilateHeader';
import { NewsfilateFooter } from '../components/NewsfilateFooter';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function NewsfilatePrivacyPolicyPage() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1198">
      <NewsfilateHeader data-id="element-1199" />
      <main className="flex-grow pt-12 pb-24" data-id="element-1200">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-1201">
          <div className="mb-8" data-id="element-1202">
            <Link to="/products/newsfiliate" className="inline-flex items-center text-[#5e60ce] hover:text-[#4c4db6] font-medium" data-id="element-1203">
              <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-1204" />
              Back to Newsfiliate
            </Link>
          </div>
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 sm:p-10" data-id="element-1205">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6" data-id="element-1206">
              Privacy Policy
            </h1>
            <p className="text-gray-500 mb-8" data-id="element-1207">Last Updated: May 23, 2025</p>
            <div className="prose prose-lg max-w-none text-gray-700" data-id="element-1208">
              <p data-id="element-1209">
                Newsfiliate ("we," "our," or "us") is committed to protecting
                your privacy. This Privacy Policy explains how we collect, use,
                store, transfer, and protect your information when you use our
                Service, including our new Kit.com integration for adding Amazon
                deals to newsletters. By accessing or using the Service, you
                agree to this Privacy Policy.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1210">
                1. Information We Collect
              </h2>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1211">
                <li data-id="element-1212">
                  <strong data-id="element-1213">Personal Information:</strong> Information you provide
                  when creating an account or using the Service, such as your
                  name, email address, and contact details.
                </li>
                <li data-id="element-1214">
                  <strong data-id="element-1215">Account Data:</strong> Information from third-party
                  accounts you connect to the Service (e.g., transaction data,
                  activity logs).
                </li>
                <li data-id="element-1216">
                  <strong data-id="element-1217">Usage Data:</strong> Data about how you interact with
                  the Service (features accessed, time spent, interactions).
                </li>
                <li data-id="element-1218">
                  <strong data-id="element-1219">Device Information:</strong> Data about the device you
                  use to access the Service (IP address, browser type, operating
                  system).
                </li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1220">
                2. Legal Basis for Processing (GDPR)
              </h2>
              <p data-id="element-1221">
                If you are located in the European Economic Area (EEA), we
                process your personal data on one or more of the following
                lawful bases:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1222">
                <li data-id="element-1223">
                  <strong data-id="element-1224">Consent:</strong> You have given clear consent for us
                  to process your personal data for a specific purpose.
                </li>
                <li data-id="element-1225">
                  <strong data-id="element-1226">Contractual Necessity:</strong> Processing is
                  necessary to perform our contract with you or to take steps
                  before entering into a contract.
                </li>
                <li data-id="element-1227">
                  <strong data-id="element-1228">Legitimate Interests:</strong> Processing is necessary
                  for our legitimate interests (e.g., improving the Service),
                  provided your rights do not override those interests.
                </li>
                <li data-id="element-1229">
                  <strong data-id="element-1230">Legal Obligations:</strong> Processing is necessary to
                  comply with a legal obligation to which we are subject.
                </li>
              </ul>
              <p className="mt-4" data-id="element-1231">
                Note: We do not specifically target or market our Service to
                EU/EEA residents. However, if you are in the EU/EEA and use our
                Service, you retain all rights granted under the GDPR.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1232">
                3. International Data Transfers
              </h2>
              <p data-id="element-1233">
                Your data may be transferred to and stored on servers located
                outside your country of residence, including in the United
                States. When we transfer personal data from the EEA to countries
                without an adequacy decision, we use appropriate safeguards such
                as Standard Contractual Clauses approved by the European
                Commission.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1234">
                4. Cookies and Tracking Technologies
              </h2>
              <p data-id="element-1235">
                We use cookies and similar technologies to enhance your
                experience and analyze usage trends. If you reside in the EU, we
                will obtain your consent before placing non-essential cookies.
                You can manage your cookie preferences through our cookie
                consent banner and your browser settings.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1236">
                5. Third-Party Services (Kit.com & Amazon)
              </h2>
              <p data-id="element-1237">
                Our Service integrates with Kit.com and Amazon to enable
                newsletter creators to add Amazon deals to their newsletters.
                When you connect to these services, their privacy policies and
                terms of service will apply in addition to ours. We encourage
                you to review their privacy practices, as we do not control
                their policies.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1238">
                6. Data Security and Retention
              </h2>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1239">
                <li data-id="element-1240">
                  <strong data-id="element-1241">Data Security:</strong> We implement industry-standard
                  security measures (encryption, access controls) to protect
                  your data from unauthorized access, disclosure, alteration, or
                  destruction.
                </li>
                <li data-id="element-1242">
                  <strong data-id="element-1243">Data Retention:</strong> We retain your personal
                  information for as long as necessary to fulfill the purposes
                  outlined in this Privacy Policy, comply with our legal
                  obligations, resolve disputes, and enforce our agreements. You
                  may request deletion of your data by contacting us at
                  help@newsfiliate.co.
                </li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1244">
                7. Your Privacy Rights
              </h2>
              <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3" data-id="element-1245">
                7.1 Global Rights
              </h3>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1246">
                <li data-id="element-1247">
                  <strong data-id="element-1248">Access:</strong> Request a copy of your personal data
                  held by us.
                </li>
                <li data-id="element-1249">
                  <strong data-id="element-1250">Correction:</strong> Request corrections to inaccurate
                  or incomplete data.
                </li>
                <li data-id="element-1251">
                  <strong data-id="element-1252">Deletion:</strong> Request deletion of your personal
                  data, subject to legal requirements.
                </li>
                <li data-id="element-1253">
                  <strong data-id="element-1254">Restriction:</strong> Request restriction of
                  processing under certain conditions.
                </li>
                <li data-id="element-1255">
                  <strong data-id="element-1256">Data Portability:</strong> Request a copy of your data
                  in a portable format.
                </li>
                <li data-id="element-1257">
                  <strong data-id="element-1258">Withdraw Consent:</strong> Where processing is based
                  on consent, you may withdraw it at any time.
                </li>
              </ul>
              <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3" data-id="element-1259">
                7.2 EU/EEA Rights (GDPR)
              </h3>
              <p data-id="element-1260">If you reside in the EEA, you also have the right to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1261">
                <li data-id="element-1262">
                  Lodge a complaint with a supervisory authority in your
                  jurisdiction if you believe we have breached GDPR.
                </li>
                <li data-id="element-1263">
                  Obtain details of any safeguards applied if your data is
                  transferred outside the EEA.
                </li>
              </ul>
              <p className="mt-4" data-id="element-1264">
                Note: We have not appointed an EU Representative, as we do not
                specifically target or market to EU/EEA residents. However, we
                still comply with all applicable GDPR requirements for any
                EU/EEA users who access our Service.
              </p>
              <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3" data-id="element-1265">
                7.3 California Privacy Rights (CCPA)
              </h3>
              <p data-id="element-1266">If you are a California resident, you have the right to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1267">
                <li data-id="element-1268">
                  Request disclosure of the categories of personal information
                  collected, sources, purpose of collection, and categories of
                  third parties with whom we share it.
                </li>
                <li data-id="element-1269">
                  Opt out of the sale or sharing of your personal information.
                </li>
                <li data-id="element-1270">
                  Request deletion of your personal information, subject to
                  certain exceptions.
                </li>
                <li data-id="element-1271">
                  Not be discriminated against for exercising your CCPA rights.
                </li>
              </ul>
              <p className="mt-4" data-id="element-1272">
                To exercise any of these rights, please contact us at
                help@newsfiliate.co.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1273">
                8. Children's Privacy
              </h2>
              <p data-id="element-1274">
                Our Service is not intended for individuals under 18 years of
                age. We do not knowingly collect personal information from
                children. If we become aware that a child under 18 has provided
                us with personal data, we will promptly delete it.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1275">
                9. Changes to This Privacy Policy
              </h2>
              <p data-id="element-1276">
                We may update this Privacy Policy from time to time. Significant
                changes will be communicated via email or through the Service.
                Your continued use of the Service after the effective date
                constitutes acceptance of the updated policy.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1277">
                10. Contact Us
              </h2>
              <p data-id="element-1278">
                If you have any questions or requests regarding this Privacy
                Policy, please contact us at:
              </p>
              <p className="mt-2" data-id="element-1279">
                <strong data-id="element-1280">Email:</strong> gavin.smith@creatorboost.ai
              </p>
              <p data-id="element-1281">
                <strong data-id="element-1282">Address:</strong> 3500 S Dupont Highway, Dover, Delaware
                19901
              </p>
              <p className="mt-8 text-center font-medium" data-id="element-1283">
                Thank you for trusting Newsfiliate with your privacy.
              </p>
            </div>
          </div>
        </div>
      </main>
      <NewsfilateFooter data-id="element-1284" />
    </div>;
}